import {Locale} from '@hebcal/hdate';
import poData from './hu.po.js';
Locale.addLocale('hu', poData);
